import { render, staticRenderFns } from "./modal-add-budget.vue?vue&type=template&id=6161b08f&"
import script from "./modal-add-budget.vue?vue&type=script&lang=js&"
export * from "./modal-add-budget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports